export default "__VITE_ASSET__CZbEcTI2__";